import { motion } from "framer-motion";
import { Disc3, Users, Music4, Flame } from "lucide-react";

const surprises = [
  {
    icon: Disc3,
    title: "DJ Sets secrets",
    body: "Plusieurs DJ non annoncés monteront aux platines. Des b2b, des edits exclusifs, une sélection pensée pour ne jamais retomber.",
  },
  {
    icon: Users,
    title: "Performances dansées",
    body: "Des danseurs et performers investissent le Flow tout au long de la nuit. La piste ne sera pas la seule scène.",
  },
  {
    icon: Flame,
    title: "Invités surprises",
    body: "Des visages que tu ne t'attends pas à voir. On garde le secret jusqu'à la toute dernière seconde.",
  },
  {
    icon: Music4,
    title: "Moments live",
    body: "Des instants uniques, jamais rejoués. Ce qui se passe à Éclipse reste à Éclipse.",
  },
];

export default function Surprises() {
  return (
    <section
      id="surprises"
      data-testid="surprises-section"
      className="relative overflow-hidden border-t border-white/10 bg-[#0c0c0e] py-24 lg:py-40"
    >
      {/* huge ghost word */}
      <div className="pointer-events-none absolute inset-x-0 top-6 select-none text-center font-display text-[26vw] leading-none tracking-tighter text-white/[0.03] lg:text-[20vw]">
        SURPRISE
      </div>

      <div className="relative mx-auto max-w-[1600px] px-5 lg:px-10">
        <div className="mb-16 max-w-3xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="mb-5 font-mono-x text-xs uppercase tracking-[0.3em] text-[#FF0000]"
          >
            [ On ne dit pas tout ]
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-display text-6xl uppercase leading-[0.85] tracking-tight text-white lg:text-8xl"
          >
            Des surprises<br />
            <span className="text-[#FF0000]">toute la nuit</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 lg:text-lg"
          >
            Nokuji n’est que le début. Éclipse, c’est une nuit remplie d’imprévus : DJ, danse,
            invités secrets. Tu ne sauras vraiment ce qui t’attend qu’une fois à l’intérieur.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 gap-px sm:grid-cols-2 lg:grid-cols-4">
          {surprises.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`surprise-card-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="group relative border border-white/10 bg-white/[0.02] p-8 transition-colors duration-500 hover:border-[#FF0000]/60 hover:bg-[#FF0000]/[0.04]"
              >
                <Icon className="h-7 w-7 text-[#FF0000] transition-transform duration-500 group-hover:scale-110" />
                <h3 className="mt-6 font-display text-2xl uppercase tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.body}</p>
                <span className="absolute right-6 top-6 font-mono-x text-xs text-zinc-600">
                  0{i + 1}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
